import React from 'react';

const UnderConstruction = () => (
    <div className="home under-construction">
        <div className="construction-card">
            <div className="construction-brand">
                <img
                    src={`${process.env.PUBLIC_URL || ''}/happtrak-logo.svg`}
                    alt="HappTrak logo"
                    className="construction-logo"
                />
                <div className="construction-wordmark">
                    <div className="construction-name">HappTrak.ai</div>
                    <div className="construction-tagline">Signal without the scroll.</div>
                </div>
            </div>

            <div className="construction-content">
                <div className="construction-kicker">Under construction</div>
                <h1 className="construction-title">We are busy turning WhatsApp group chaos into calm.</h1>
                <p className="construction-copy">
                    We are polishing the beta experience right now. Check back soon for the signup page and we will
                    reopen access as soon as the next wave is ready.
                </p>
                <div className="construction-status">
                    <span className="construction-dot" aria-hidden="true" />
                    <span>Beta access reopening soon.</span>
                </div>
                <a className="construction-link" href="/delete-account">
                    Request account deletion
                </a>
            </div>
        </div>
    </div>
);

export default UnderConstruction;
